import React from 'react';
import styled from 'styled-components';
import { Link as StyledLink, utils } from '@makeship/core';
import { S2, P2, H1, H2, H3, H4, H5, H6, S1Styles } from '../../../Typography';
import { transformHtml } from '../../../../utils/htmr';
import { getProductFromContext } from '../../../../context/product';

const CreatorMessageWrapper = styled.div`
  margin-top: 32px;
  margin-bottom: 32px;
  border: 1px solid ${({ theme }) => utils.hexToRGBA(theme.colors.neutral7, theme.alpha.light)};
  border-radius: 12px;
  padding: 12px 8px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    padding: 18px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    margin-top: 24px;
    margin-bottom: 24px;
  }
`;

const CreatorHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    margin-bottom: 16px;
  }
`;

const CreatorHeader = styled(S2)`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    ${S1Styles}
  }
`;

const DescriptionP = styled(P2)``;

const CreatorMessage: React.FC = () => {
  const product = getProductFromContext();

  return (
    <CreatorMessageWrapper>
      <CreatorHeaderWrapper>
        <CreatorHeader>Message from the Creator</CreatorHeader>
      </CreatorHeaderWrapper>
      {transformHtml(product.descriptionHtml, {
        p: DescriptionP,
        div: DescriptionP,
        a: StyledLink.Primary,
        h1: H1,
        h2: H2,
        h3: H3,
        h4: H4,
        h5: H5,
        h6: H6,
      })}
    </CreatorMessageWrapper>
  );
};

export default CreatorMessage;
